import { useEffect, useMemo, useState } from 'react';
import api from '../../api/client';

export default function Diagnosticos() {
  const [items, setItems]       = useState([]);
  const [modal, setModal]       = useState(null);
  const [loading, setLoading]   = useState(true);
  const [busqueda, setBusqueda] = useState('');

  const cargar = async () => {
    setLoading(true);
    const r = await api.get('/alimentacion/diagnosticos');
    setItems(r.data);
    setLoading(false);
  };
  useEffect(() => { cargar(); }, []);

  /* ---------- Filtrado en memoria ---------- */
  const itemsFiltrados = useMemo(() => {
    const q = busqueda.trim().toLowerCase();
    if (!q) return items;
    return items.filter((d) =>
      (d.nombre || '').toLowerCase().includes(q)
    );
  }, [items, busqueda]);

  /* ---------- CRUD ---------- */
  const guardar = async (form) => {
    try {
      if (form.id) await api.put(`/alimentacion/diagnosticos/${form.id}`, form);
      else         await api.post('/alimentacion/diagnosticos', form);
      setModal(null);
      cargar();
    } catch (e) {
      alert(e.response?.data?.error || 'Error al guardar');
    }
  };

  const eliminar = async (id) => {
    if (!confirm('¿Eliminar este diagnóstico? Esta acción no se puede deshacer.')) return;
    try {
      await api.delete(`/alimentacion/diagnosticos/${id}`);
      cargar();
    } catch (e) {
      alert(e.response?.data?.error || 'Error al eliminar');
    }
  };

  return (
    <div className="p-6 space-y-4">
      {/* Barra superior */}
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="text-2xl font-bold">Diagnósticos</h1>

        <button
          onClick={() => setModal({})}
          className="ml-auto bg-sky-600 hover:bg-sky-700 text-white px-4 py-2 rounded"
        >
          + Nuevo diagnóstico
        </button>
      </div>

      {/* Filtro de búsqueda */}
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-3">
        <div className="flex items-center gap-2">
          <span className="text-gray-400">🔎</span>
          <input
            type="text"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="Buscar diagnóstico por nombre…"
            className="flex-1 border-0 focus:outline-none focus:ring-0 text-sm"
          />
          {busqueda && (
            <button
              onClick={() => setBusqueda('')}
              className="text-gray-400 hover:text-gray-700 text-sm"
              title="Limpiar"
            >
              ✕
            </button>
          )}
        </div>
        <div className="text-xs text-gray-500 mt-1">
          Mostrando <strong>{itemsFiltrados.length}</strong> de{' '}
          <strong>{items.length}</strong> diagnósticos
        </div>
      </div>

      {/* Tabla */}
      <div className="bg-white rounded-xl shadow overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-500 text-left">
            <tr>
              <th className="px-4 py-3 w-16">#</th>
              <th className="px-4 py-3">Nombre</th>
              <th className="px-4 py-3 w-32 text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan="3" className="p-6 text-center text-gray-400">
                  Cargando…
                </td>
              </tr>
            )}
            {!loading && items.length === 0 && (
              <tr>
                <td colSpan="3" className="p-6 text-center text-gray-400">
                  Sin registros
                </td>
              </tr>
            )}
            {!loading && items.length > 0 && itemsFiltrados.length === 0 && (
              <tr>
                <td colSpan="3" className="p-6 text-center text-gray-400">
                  No hay diagnósticos que coincidan con «{busqueda}»
                </td>
              </tr>
            )}
            {itemsFiltrados.map((d, i) => (
              <tr key={d.id} className="border-t">
                <td className="px-4 py-2 text-gray-400">{i + 1}</td>
                <td className="px-4 py-2">{d.nombre}</td>
                <td className="px-4 py-2 text-right whitespace-nowrap">
                  <button
                    onClick={() => setModal(d)}
                    className="text-sky-600 hover:underline mr-3"
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => eliminar(d.id)}
                    className="text-red-600 hover:underline"
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <ModalDiagnostico
          item={modal}
          onCancel={() => setModal(null)}
          onSave={guardar}
        />
      )}
    </div>
  );
}

/* =========================================================
   Modal
   ========================================================= */
function ModalDiagnostico({ item, onCancel, onSave }) {
  const [nombre, setNombre] = useState(item.nombre || '');

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="px-5 py-3 border-b font-semibold">
          {item.id ? 'Editar' : 'Nuevo'} diagnóstico
        </div>
        <div className="p-5">
          <label className="block">
            <span className="text-sm font-medium">
              Nombre <span className="text-red-500">*</span>
            </span>
            <input
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="mt-1 w-full border rounded px-3 py-2"
              autoFocus
            />
          </label>
        </div>
        <div className="px-5 py-3 border-t flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 rounded border">
            Cancelar
          </button>
          <button
            onClick={() => onSave({ id: item.id || null, nombre })}
            className="px-4 py-2 rounded bg-sky-600 text-white hover:bg-sky-700"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}